import { DiscountType, PromoTypeEnum } from '../../../../api/types';
import useValidator from '../../../../utilities/useValidator';
import validators from '../../../../utilities/validators';

export const validator = validators.compose(
    validators.requiredString('promoCode'),
    validators.requiredArray('applicationModuleIds'),
    validators.requiresPeriod('period'),
    validators.requiresTimePicker('startTime', true),
    validators.requiresTimePicker('endTime', true),
    validators.only(
        ({ promoType: { type } }) => type === PromoTypeEnum.Gift,
        validators.requiredString('promoType.giftPromoType.description')
    ),
    validators.only(
        ({ promoType: { type } }) => type === PromoTypeEnum.Discount,
        validators.compose(
            validators.requiredString('promoType.discountPromoType.description'),
            validators.requiredNumber('promoType.discountPromoType.amount'),
            validators.requiredStringEnum('promoType.discountPromoType.discountType', DiscountType),
            validators.only(
                promoCode => promoCode.promoType.discountPromoType.discountType === DiscountType.Percentage,
                validators.compose(
                    validators.custom('promoType.discountPromoType.amount', (defaultValue, values, errors, context) => {
                        if (100 < defaultValue) {
                            return context.defaultMessages.validatePercentage;
                        }

                        return null;
                    }),
                    validators.validNumberMin('promoType.discountPromoType.amount', 0)
                )
            )
        )
    ),
    validators.only(({ trackUsage }) => trackUsage, validators.requiredNumber('initialQuantity'))
);

const usePromoCodeFormValidator = () => useValidator(validator);

export const useCreatePromoCodeFormValidator = () =>
    useValidator(validators.compose(validator, validators.requiredString('moduleId')));

export default usePromoCodeFormValidator;
